import React from 'react';
import styled from 'styled-components';
import Menu from '../../../components/Menu/Navbar';
import Header from '../../../components/Header/header';
import Logo from '../../../components/Logo/logo';
import Footer from '../../../components/Footer/footer';
import FxView from '../../../components/FxView/fxview';

const ContainerGeneral = styled.div`
  margin: 140px auto;
  width: 75%;
  padding: 20px;
  min-height: 500px;

  @media (max-width: 768px) {
    width: 100%;
    padding: 15px;
  }
`;

const TituloGrande = styled.h1`
  font-family: 'GarnetLight';
  font-weight: bold;
  margin: 10px 0;
  margin-top: 50px;
  text-align: left;
  color: #a0f000;
  font-size: 28px;

  @media (max-width: 768px) {
    font-size: 24px;
  }
`;

const Texto = styled.p`
  font-size: 17px;
  line-height: 1.7;
  color: #000000;
  margin: 25px 0;
  text-align: left;

  @media (max-width: 768px) {
    font-size: 16px;
    line-height: 1.6;
  }
`;

const Lista = styled.ul`
  font-size: 17px;
  line-height: 1.8;
  color: #000000;
  margin: 25px 0;
  padding-left: 25px;

  li {
    margin-bottom: 10px;
  }

  @media (max-width: 768px) {
    font-size: 16px;
    line-height: 1.6;
    padding-left: 20px;
  }
`;

const Correo = styled.a`
  color: #a0f000;
  text-decoration: none;
  font-weight: bold;

  &:hover {
    text-decoration: underline;
  }
`;

const Despedida = styled.div`
  font-size: 17px;
  line-height: 1.7;
  color: #000000;
  margin-top: 35px;
  margin-bottom: 40px;

  @media (max-width: 768px) {
    font-size: 16px;
    line-height: 1.6;
  }
`;

/* =========================
   DOCUMENTACIÓN
========================= */

const Documentacion = styled.div`
  margin-top: 50px;
  margin-bottom: 50px;
`;

const DocumentacionTitulo = styled.h2`
  font-size: 22px;
  font-weight: bold;
  color: #000000;
  margin-bottom: 25px;
`;

const DocumentosGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 25px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 20px;
  }
`;

const Documento = styled.div`
  background: #ffffff;
  border: 1px solid #e5e5e5;
  border-left: 4px solid #a0f000;
  padding: 25px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 25px;
  transition: all 0.25s ease;
  box-shadow: 0 3px 12px rgba(0, 0, 0, 0.06);

  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 7px 20px rgba(0, 0, 0, 0.1);
    border-left-color: #8dcc00;
  }

  @media (max-width: 768px) {
    padding: 20px;
    flex-direction: column;
    align-items: flex-start;
  }
`;

const DocumentoInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 18px;
`;

const IconoPDF = styled.div`
  width: 48px;
  height: 48px;
  min-width: 48px;
  background: #f3f3f3;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  font-weight: bold;
  color: #555555;
  border: 1px solid #e1e1e1;
`;

const DocumentoTexto = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

const DocumentoNombre = styled.span`
  font-size: 17px;
  font-weight: bold;
  color: #000000;
`;

const DocumentoDescripcion = styled.span`
  font-size: 14px;
  color: #777777;
`;

const BotonDescarga = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-width: 150px;
  padding: 12px 18px;
  background: #a0f000;
  color: #000000;
  text-decoration: none;
  font-size: 14px;
  font-weight: bold;
  letter-spacing: 0.3px;
  transition: all 0.2s ease;
  white-space: nowrap;

  &:hover {
    background: #8dcc00;
    transform: translateY(-1px);
  }

  &:active {
    transform: translateY(0);
  }

  @media (max-width: 768px) {
    width: 100%;
  }
`;

const EscuelaDeFormacion = () => {
  return (
    <div>
      <Menu />
      <Header />
      <Logo />
      <FxView />

      <ContainerGeneral>

        <TituloGrande>
          LICENCIA FEDERATIVA Y DE AFICIONADO 26 - 27
        </TituloGrande>

        <Texto>
          Desde Net Sport Tennis Academy & Club Río Grande nos ponemos en
          contacto con vosotros para informaros de todo lo relacionado con
          las licencias deportivas correspondientes a la temporada 2026/2027.
        </Texto>

        <Texto>
          Con el objetivo de facilitar la gestión y evitar cualquier duda
          durante el proceso, adjuntamos la documentación correspondiente,
          donde podréis consultar toda la información detallada sobre las
          licencias Federativa y de Aficionado, así como los requisitos y
          pasos necesarios para su tramitación.
        </Texto>

        <Texto>
          Os rogamos que leáis detenidamente la documentación adjunta,
          prestando especial atención a los siguientes aspectos:
        </Texto>

        <Lista>
          <li>
            <strong>Tipos de licencia disponibles:</strong> Licencia
            Federativa y Licencia de Aficionado.
          </li>

          <li>
            <strong>Renovación de la licencia:</strong> procedimiento que
            deberán seguir aquellos alumnos y alumnas que ya dispusieran de
            licencia en la temporada anterior.
          </li>

          <li>
            <strong>Nueva alta:</strong> procedimiento para aquellos jugadores
            y jugadoras que soliciten la licencia por primera vez.
          </li>

          <li>
            <strong>Documentación necesaria</strong> para completar
            correctamente la tramitación.
          </li>

          <li>
            <strong>Proceso de solicitud y pago,</strong> según corresponda
            a cada modalidad.
          </li>

          <li>
            <strong>Plazos establecidos</strong> para realizar la gestión de
            las licencias.
          </li>
        </Lista>

        <Texto>
          Es muy importante que cada alumno o alumna compruebe qué tipo de
          licencia necesita y siga correctamente las instrucciones indicadas
          en la documentación adjunta, con el fin de que la tramitación se
          realice de manera ágil y sin incidencias.
        </Texto>

        <Texto>
          Desde la Dirección de Net Sport Tennis Academy & Club Río Grande
          queremos agradeceros, una temporada más, vuestra confianza y
          compromiso con nuestro proyecto deportivo.
        </Texto>

        <Texto>
          Para cualquier duda o aclaración relacionada con el proceso de alta
          o renovación, podéis poneros en contacto con la compañera de
          administración de Club Río Grande, Alba Cabrera, a través del correo
          electrónico{' '}
          <Correo href="mailto:administracion@riogrande.es">
            administracion@riogrande.es
          </Correo>
          .
        </Texto>

        <Texto>
          Muchas gracias por vuestra colaboración.
        </Texto>

        <Despedida>
          Un cordial saludo,
          <br />
          <br />
          <strong>La Dirección</strong>
          <br />
          Net Sport Tennis Academy & Club Río Grande
        </Despedida>

        {/* =========================
            DOCUMENTACIÓN
        ========================= */}

        <Documentacion>

          <DocumentacionTitulo>
            DOCUMENTACIÓN
          </DocumentacionTitulo>

          <DocumentosGrid>

            {/* PDF 1 */}

            <Documento>
              <DocumentoInfo>
                <IconoPDF>
                  PDF
                </IconoPDF>

                <DocumentoTexto>
                  <DocumentoNombre>
                    Licencia Federativa y de Aficionado
                  </DocumentoNombre>

                  <DocumentoDescripcion>
                    Temporada 2026 - 2027
                  </DocumentoDescripcion>
                </DocumentoTexto>
              </DocumentoInfo>

              <BotonDescarga
                href="/PDF/LICENCIA%20FEDERATIVA%20Y%20DE%20AFICIONADO%2026%20-%2027.pdf"
                target="_blank"
                rel="noopener noreferrer"
                download
              >
                ↓ DESCARGAR PDF
              </BotonDescarga>
            </Documento>

       {/* EXCEL */}

            <Documento>
              <DocumentoInfo>
                <IconoPDF>
                  XLSX
                </IconoPDF>

                <DocumentoTexto>
                  <DocumentoNombre>
                    Excel de Petición Licencia Aficionado
                  </DocumentoNombre>

                  <DocumentoDescripcion>
                    Temporada 2025 - 2026
                  </DocumentoDescripcion>
                </DocumentoTexto>
              </DocumentoInfo>

              <BotonDescarga
                href="/PDF/Peticion%20licencias%20clubes%20aficionado%202025-2026%202.xlsx"
                target="_blank"
                rel="noopener noreferrer"
                download
              >
                ↓ DESCARGAR EXCEL
              </BotonDescarga>
            </Documento>

            {/* PDF 2 */}

            <Documento>
              <DocumentoInfo>
                <IconoPDF>
                  PDF
                </IconoPDF>

                <DocumentoTexto>
                  <DocumentoNombre>
                    FATENIS Licencias
                  </DocumentoNombre>

                  <DocumentoDescripcion>
                    Temporada 2026 - 2027
                  </DocumentoDescripcion>
                </DocumentoTexto>
              </DocumentoInfo>

              <BotonDescarga
                href="/PDF/FATENIS%20LICENCIAS%2026%20-%2027.pdf"
                target="_blank"
                rel="noopener noreferrer"
                download
              >
                ↓ DESCARGAR PDF
              </BotonDescarga>
            </Documento>

     

          </DocumentosGrid>

        </Documentacion>

      </ContainerGeneral>

      <Footer />
    </div>
  );
};

export default EscuelaDeFormacion;

